import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { Block } from '../../other/block';

const Brand = styled.div`
  background-color: #f7f3eb;
  align-self: center;
`;

const BrandImage = styled.img`
  transition: all 1s ease-out;
  transition-duration: 700ms;
`;

interface BrandsProps {
  headline: string;
  brandImages: Asset[];
  backgroundColour?: string;
}

export const Brands: React.FC<BrandsProps> = ({ headline, brandImages }) => {
  const gridOrFlex = 'grid grid-cols-3 gap-2 lg:grid-cols-6';

  return (
    <Block backgroundColour={'transparent'}>
      <h2 className="text-xl text-center uppercase mb-10">{headline}</h2>

      <div className="max-w-7xl mx-auto">
          <div className={gridOrFlex}>
            {brandImages.map((brandImage, index) => (
              <Brand key={index} className={`w-auto p-3 ${brandImages.length < 6 ? 'flex-1 mr-3' : ''}`}>
                <BrandImage className="" src={brandImage.url} alt={brandImage.name} />
              </Brand>
            ))}
          </div>
      </div>
    </Block>
  );
};
